import type { FaireProductEntity } from "../../entity_types/product";

export const p_cbvzrmu7dk: FaireProductEntity = {
  token: "p_cbvzrmu7dk",
  type: "product",
  name: "Rabbit Short Necklace",
  brandToken: "b_d5xrgr19y5",
  brandName: "Fable England",
  imageUrl:
    "https://cdn.faire.com/fastly/873c90012cc82b8093998e9afe0c32a95ee51eac43e58210e3b6e1251e1cac89.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/19dad2f545ddf80759b1286cba7e130e05baecd87aee44eaa356a0f62a4d6e97.jpeg",
    "https://cdn.faire.com/fastly/56742eec7f7e005a48b74febb5e869238b1ab49d0f7921ecca7d75ffb0aa2728.jpeg",
    "https://cdn.faire.com/fastly/349193b078a102fb016b28ec013f50564f92d06e65b07d6ded34d31eacab5813.jpeg",
    "https://cdn.faire.com/fastly/9581fd17b947b0f7885557cc26ef8ccd4b58b1695f5d887559cd5e58c7d21f84.jpeg",
    "https://cdn.faire.com/fastly/70c1689d452a7946f4b30031641537f1d7e0e4b956315e5fe5cf3a5564b6dd07.jpeg",
    "https://cdn.faire.com/fastly/a8a7c71a192d01ad6e507a4d47fe78189b05dd5382865b1dd08e1275eb3f9b03.jpeg",
    "https://cdn.faire.com/fastly/dff61b07196ade1cfe5321486b68eb30a8cdee5c5dd1f0f0ac48df9c79b80abb.jpeg",
  ],
  priceDollars: 21,
  description:
    "Adorn your neckline with our adorable Rabbit Necklace, carefully crafted in enamel and hand painted for a delightfully, charming finish. Set in an inquisitive, content pose, our Fable bunny looks like it’s just hopped out of the forest and into the meadow, looking for some tasty treats to devour. Gift your love ones one of our unique charm necklaces or begin your own woodland animal collection.\n\nKey features:\n\n * Hand-painted enamel \n * Hand-carved detailing \n * Charm: 14k gold-plated zinc alloy, enamel; Chain 14k gold-plated brass \n * 41cm Chain with 5cm extender; Pendant: 2.2 x 2 cm \n * Comes in a gift box with cotton pouch",
  tags: [],
  msrpDollars: 52,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:54:03.535Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
